import { render, staticRenderFns } from "./BudgetSheet.vue?vue&type=template&id=2073dca7&scoped=true"
import script from "./BudgetSheet.vue?vue&type=script&lang=ts"
export * from "./BudgetSheet.vue?vue&type=script&lang=ts"
import style0 from "./BudgetSheet.vue?vue&type=style&index=0&id=2073dca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073dca7",
  null
  
)

export default component.exports